export const SORT_BY_TYPES = {
  MODIFICATION_DATE: '-edited_at',
  CREATION_DATE: '-created_at',
  DATE_JOINED_DESC: '-date_joined',
  ALPHABETHICALLY: 'name',
  APPROVED_DATE_DESC: '-approved_at',
  APPROVED_DATE_ASC: 'approved_at',
  REVIEWED_DATE_DESC: '-last_review_at',
  REVIEWED_DATE_ASC: 'last_review_at',
  REVIEWED_DATE_NEXT_ASC: 'next_review_at',
  RANK: '-rank',
  LAST_SIGNED_OFF_DATE_DESC: '-last_signoff_at,name',
  LAST_REQUEST_SENT_DATE_DESC: '-last_request_sent_at,-last_signoff_at,name',
  DUE_DESC: '-due',
  DUE: 'due',
  ALPHABETICALLY_CURRENT_NAME: 'current_name',
  DELETION_DATE: '-modified_at',
};

export type SortOptionType = typeof SORT_BY_TYPES[keyof typeof SORT_BY_TYPES];

export const DEFAULT_PAGE_SIZE = 50;
export const UNLIMITED_PAGE_SIZE = 1000;
export const SIDEBAR_PAGE_SIZE = 20;
export const SELECT_PAGE_SIZE = 20;

export const DEFAULT_LANG = 'en';

export const LOCAL_IMAGE_URL_ATTR_NAME = 'data-local-url';
export const LOCAL_IMAGE_HOTLINKED_ATTR_NAME = 'data-image-failed-at';

export const PRESENCE_BEACON_WAIT_MULTIPLIER = 3;

// step collapse duration
export const COLLAPSE_DURATION_MS = 500;

// fake domain added to the requests in the tests, because node can't request
// partials URLs, it needs a domain. We intercept the request before it's sent
export const FAKE_TEST_DOMAIN = 'http://fake.test.local';

export const MAX_FILESIZE_UPLOAD = {
  bytes: 100 * 1024 * 1024,
  humanReadable: '100MB',
};

export const INFINITE = 100000;

export const MAX_ANSWERS_PER_QUESTION = 5;

export const RECYCLEABLE_CONTENT_TYPES = {
  PROCEDURE: 'procedure',
  PROCEDURE_VERSION: 'procedureversion',
  PROCESS: 'proceduregroup',
  PROCESS_VERSION: 'processversion',
  POLICY: 'policy',
  POLICY_VERSION: 'policyversion',
  QUIZ: 'quiz',
  QUIZ_VERSION: 'quizversion',
  ATTEMPT: 'attempt',
  LANE: 'lane',
  FOLDER: 'folder',
};

export type RecycleableContentTypeOptionType =
  typeof RECYCLEABLE_CONTENT_TYPES[keyof typeof RECYCLEABLE_CONTENT_TYPES];

// VALIDATION/API ERRORS
export const INVALID_VERSION_CODE = 'INVALID_VERSION';

// Tasks
export const AUTOMATION_RETRY_LIMIT = 120; // seconds
